﻿export interface IFailSafeAcknowledgeAlert {
    chainId: number,
    clusterNumber: number,
    positionNumber: number,
    acknowledgedBy: number,
    issueDescription: string,
    planDescription: string
}
